import { render, staticRenderFns } from "./VehiculosPage.vue?vue&type=template&id=1a158c74&scoped=true&"
import script from "./VehiculosPage.vue?vue&type=script&lang=js&"
export * from "./VehiculosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a158c74",
  null
  
)

export default component.exports